<template>
  <div class="common-form" :class="type === 'dark' ? 'dark' : 'light'">
<!--    <product-select @select="handleSelectProduct" v-if="showProductSelect"></product-select>-->
    <van-field placeholder="请填写姓名" label="姓名" required v-model="form.realName"></van-field>
    <van-field placeholder="请填写手机号码" label="手机号码" required v-model="form.mobile" @focus="hideError">
      <template slot="right-icon">
        <span class="error-message" v-show="phoneFormatError">格式错误</span>
      </template>
    </van-field>
    <van-field placeholder="请填写公司信息" label="公司名称" required v-model="form.companyName"></van-field>
    <area-select :isLineFeed="true" placeholder="请选择公司所在地区" label="所在地区" required @select="handleSelectArea"></area-select>
    <van-field placeholder="请输入" label="详细地址(详细到省市区街道)" required v-model="form.companyAddress"></van-field>
    <div class="ip-content">
      <van-field placeholder="CA65CA/CA75CA" label="设备型号" required v-model="form.mbModel"/>
      <van-field placeholder="12/20" class="rooms" label="数量" required v-model="form.machineNum"/>
    </div>
    <div class="rol2">
      标记*为必填项。<span class="tips">巡检仅限会议平板用户。</span><br>
      <span>*如有多种设备型号的会议平板，请用/隔开型号和对应数量。</span> <br>
      <span>*请完整填写表单，信息不齐全将影响后续无法服务。</span>
      <br>
      <span>*参与本次活动，MAXHUB将会选择部分用户进行服务现场拍摄与外部传播。</span> <br>
      <span>*巡检机子超过10台，MAXHUB将视为用户默认同意对其员工进行服务体验采访。</span>
    </div>
    <submit-button :class="isTable ? 'form-btn' : ''" :isNewsForm="true"  @click="submitForm" :disabled="buttonDisbled" :loading="submitLoading"></submit-button>
  </div>
</template>

<script>
import FormMixins from '@mixins/form-mixins';
export default {
  name: 'ServiceMonthForm',
  mixins: [FormMixins],
  props: {
    type: { // 有两种值，dark和light，dark则表单的文字是黑灰色，light则表单的文字是白色
      type: String,
      default: 'light'
    },
    showProductSelect: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './ServiceMonthForm.scss';
</style>
